export enum message_type {
  TEXT = 'TEXT',
  VOICE = 'VOICE',
  INVISIBLE = 'INVISIBLE',
  TEXT_INTERRUPTED = 'TEXT_INTERRUPTED',
  VOICE_INTERRUPTED = 'VOICE_INTERRUPTED',
}

export enum author_type {
  USER = 'user',
  ASSISTANT = 'assistant',
  VALIDATOR = 'validator',
  BLOCKED_ASSISTANT = 'blocked_assistant',
}
